/* Import defaults */
import Vue from 'vue';

/* Import packages */
import Vuex from 'vuex';
import PersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';

/* Assign defaults */
Vue.use(Vuex);
const ls = new SecureLS({ isCompression: true });

export default new Vuex.Store({
	strict: false,
	plugins: [
		PersistedState({
			key: 'brdovec.hr',
			// storage: {
			//   getItem: (key) => ls.get(key),
			//   setItem: (key, value) => ls.set(key, value),
			//   removeItem: (key) => ls.remove(key),
			// }
		})
	],
	state: {
		cookies: false,
		loading: false,
		expiration: null,
	},
	mutations: {
		setCookies (state, data) {
			state.cookies = data;
		},
		setLoading (state, data) {
			state.loading = data;
		},
		setExpiration (state, data) {
			state.expiration = data;
		},
		reinitializeData (state) {
			state.cookies = false;
			state.loading = false;
			state.expiration = new Date();
		},
		reinitializeApplication (state) {
			state.cookies = false;
			state.loading = false;
			state.expiration = new Date();
		}
	},
	actions: {
		setCookies ({commit}, data) {
			commit('setCookies', data);
		},
		setLoading ({commit}, data) {
			commit('setLoading', data);
		},
		setExpiration ({commit}, data) {
			commit('setExpiration', data);
		},
		reinitializeData ({commit}) {
			commit('reinitializeData');
		},
		reinitializeApplication ({commit}) {
			commit('reinitializeApplication');
		}
	}
})



// WEBPACK FOOTER //
// ./resources/assets/js/store/Index.js